import React from 'react';
import { Link } from 'react-router-dom';
import arrowIcon from 'assets/img/icons/arrow-right.svg';

import './style.sass';
import { ReactSVG } from 'react-svg';
import { Spinner } from '../../Spinner';

export type TableRowProps = React.PropsWithChildren<{
    className?: string,
    cellsClassName?: string,
    onClick?: () => void,
    to?: string,
    isLoading?: boolean,
}>;

export const TableRow = ({
    className,
    onClick,
    children,
    cellsClassName,
    to,
    isLoading,
}: TableRowProps) => {
    const bodyRowClass = `table-row ${className ? className : ''}`;
    const bodyRowCellClass = `table-cell ${cellsClassName ? cellsClassName : ''}`;


    const content = (
        React.Children.map(children, (cell, cellIndex) => {
            if (cell) {
                return (
                    <div
                        className={bodyRowCellClass}
                        key={`cell_${cellIndex}`}
                    >
                        {cell}
                    </div>
                );
            }
        })
    );
    return to
        ? <Link className={bodyRowClass} to={to}>
            {content}

            <div className="table-row__button">
                <ReactSVG src={arrowIcon} />
            </div>

            {isLoading &&
                <div className="table-row__loader">
                    <Spinner/>
                </div>
            }
        </Link>
        : <div className={bodyRowClass} onClick={onClick}>
            {content}

            <div className="table-row__button">
                <ReactSVG src={arrowIcon} />
            </div>

            {isLoading &&
                <div className="table-row__loader">
                    <Spinner/>
                </div>
            }
        </div>;
};
